import React from "react";
import { FaFacebook, FaInstagram, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#e8e4dc", // soft earthy beige
        padding: "40px 20px",
        textAlign: "center",
        color: "#3b3b3b",
        borderTop: "2px solid #c7d3c2",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <h3
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: "600",
          color: "#4c6042",
          letterSpacing: "1px",
          marginBottom: "15px",
        }}
      >
        CreatorFlow
      </h3>

      <p
        style={{
          fontSize: "15px",
          maxWidth: "600px",
          margin: "0 auto 20px",
          color: "#555",
          lineHeight: "1.6",
        }}
      >
        Empowering creators to organize ideas, plan reminders, and stay inspired every day.
      </p>

      {/* Social Links */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        <a
          href="https://facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          style={iconLinkStyle}
        >
          <FaFacebook size={24} />
        </a>
        <a
          href="https://instagram.com"
          target="_blank"
          rel="noopener noreferrer"
          style={iconLinkStyle}
        >
          <FaInstagram size={24} />
        </a>
        <a href="mailto:creatorflow@example.com" style={iconLinkStyle}>
          <FaEnvelope size={24} />
        </a>
        <a href="tel:+15551234567" style={iconLinkStyle}>
          <FaPhoneAlt size={22} />
        </a>
      </div>

      {/* Contact info */}
      <p style={{ fontSize: "14px", color: "#6b705c", marginBottom: "8px" }}>
        📞 (555) 123-4567 | ✉️ creatorflow@example.com
      </p>

      <p style={{ fontSize: "13px", color: "#777" }}>
        © {new Date().getFullYear()} <strong>CreatorFlow</strong>. All rights reserved.
      </p>
    </footer>
  );
}

const iconLinkStyle = {
  color: "#4c6042",
  transition: "all 0.3s ease",
  textDecoration: "none",
};

iconLinkStyle[':hover'] = {
  color: "#a98467",
  transform: "scale(1.2)",
};
